<template>
    <div class="tw-px-4">
        <div class="tw-grid tw-grid-cols-12 tw-gap-4">
            <div class="tw-col-span-12 md:tw-col-span-3">
                <div
                    class="tw-w-full tw-min-h-[300px] tw-bg-white tw-rounded-lg tw-p-2 tw-border tw-border-solid tw-border-primary-200">
                    <!-- My Eshow Sidebar Navigation -->
                    <div class="tw-space-y-2">
                        <div v-for="item in navigationItems" :key="item.id" @click="setActiveItem(item.id)" :class="[
                            'tw-w-full tw-p-3 tw-rounded-md tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-transition-colors tw-duration-200',
                            activeItem === item.id
                                ? 'tw-bg-primary-500 tw-text-white'
                                : 'tw-bg-white tw-text-gray-700 hover:tw-bg-primary-50 hover:tw-text-primary-700'
                        ]">
                            <div :class="[
                                'tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-shrink-0',
                                activeItem === item.id ? 'tw-text-white' : 'tw-text-gray-500'
                            ]">
                                <icon :icon="item.icon" class="tw-text-lg" />
                            </div>
                            <span class="tw-font-medium tw-text-sm">{{ item.label }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="false" class="tw-col-span-12 md:tw-col-span-3 tw-mt-4">
                    <div
                        class="tw-w-full tw-bg-white tw-rounded-lg tw-p-4 tw-border tw-border-solid tw-border-primary-200">
                        <!-- Download Schedule Section -->
                        <div class="tw-flex tw-flex-col tw-h-full">
                            <div class="tw-flex-1">
                                <h1 class="tw-text-2xl tw-font-bold tw-text-primary-800 tw-mb-4">Download your schedule
                                </h1>
                                <p class="tw-text-gray-600 tw-leading-relaxed tw-mb-8">
                                    Export your sessions, meetings and bookmarks in a single printable PDF file.
                                </p>
                            </div>

                            <div class="tw-mt-auto tw-flex tw-justify-end">
                                <a-button @click="downloadSchedule" class="">
                                    Download
                                </a-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-col-span-12 md:tw-col-span-9">
                <div
                    class="tw-w-full tw-min-h-[300px] tw-bg-white tw-rounded-lg tw-p-4 tw-border tw-border-solid tw-border-primary-200">
                    <div class="tw-w-full tw-overflow-hidden">
                        <transition class="tw-duration-200" enter-from-class="tw-opacity-0 tw-translate-x-[10px]"
                            leave-to-class="tw-opacity-0 -tw-translate-x-[10px]" mode="out-in">
                            <component :is="tab.component" />
                        </transition>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
import { ref, shallowRef } from 'vue';
import { useRoute } from "vue-router";
import MyScheduleTab from '@/components/my-eshow/tabs/MyScheduleTab';
import MyMeetingsTab from '@/components/my-eshow/tabs/MyMeetingsTab';
import MyNetworkTab from '@/components/my-eshow/tabs/MyNetworkTab';
import MyBookmarkedCompaniesTab from '@/components/my-eshow/tabs/MyBookmarkedCompaniesTab';
import MyBookmarkedProductsTab from '@/components/my-eshow/tabs/MyBookmarkedProductsTab';
import MyBookmarkedServicesTab from '@/components/my-eshow/tabs/MyBookmarkedServicesTab';

const route = useRoute();
const tabs = [
    {
        key: "schedule",
        component: MyScheduleTab,
        name: "My schedule",
        icon: "solar:calendar-linear",
    },
    {
        key: "meetings",
        component: MyMeetingsTab,
        name: "My Meetings",
        icon: "solar:users-group-rounded-linear",
    },
    {
        key: "network",
        component: MyNetworkTab,
        name: "My Network",
        icon: "solar:share-circle-linear",
    },
    {
        key: "bookmarked-companies",
        component: MyBookmarkedCompaniesTab,
        name: "Saved Companies",
        icon: "solar:buildings-2-linear",
    },
    {
        key: "bookmarked-products",
        component: MyBookmarkedProductsTab,
        name: "Saved Products",
        icon: "solar:shopping-bag-linear",
    },
    {
        key: "bookmarked-services",
        component: MyBookmarkedServicesTab,
        name: "Saved Services",
        icon: "solar:service-linear",
    }
];

let selected = tabs[0];

if (route.query?.tab) {
    selected = tabs.find(t => t.key == route.query?.tab) ?? tabs[0];
}

const tab = shallowRef(selected);

const onClick = t => {
    // const urlParams = new URLSearchParams(window.location.search);
    // urlParams.set('tab', t.key);

    // // Use history.replaceState to update the URL without reloading the page
    // const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    // history.replaceState(null, '', newUrl);

    tab.value = t;
};


// Navigation items based on the image
const navigationItems = ref([
    {
        id: 'schedule',
        label: 'My Schedule',
        icon: 'solar:calendar-linear'
    },
    {
        id: 'meetings',
        label: 'My Meetings',
        icon: 'solar:users-group-rounded-linear'
    },
    {
        id: 'network',
        label: 'My Network',
        icon: 'solar:share-circle-linear'
    },
    {
        id: 'bookmarked-companies',
        label: 'Saved Companies',
        icon: 'solar:buildings-2-linear'
    },
    {
        id: 'bookmarked-products',
        label: 'Saved Products',
        icon: 'solar:box-linear'
    },
    {
        id: 'bookmarked-services',
        label: 'Saved Services',
        icon: 'solar:settings-linear'
    },
    // {
    //     id: 'wishlist',
    //     label: 'My wish-list',
    //     icon: 'solar:bookmark-linear'
    // }
])

// Active item state - default to "My schedule" as shown in image
const activeItem = ref('schedule')

// Handle navigation item clicks
const setActiveItem = (itemId) => {
    activeItem.value = itemId
    onClick(tabs.find(t => t.key == itemId))
    console.log('Navigation to:', itemId)
    // TODO: Add actual navigation logic here
}

// Handle download schedule
const downloadSchedule = () => {
    console.log('Downloading schedule...')
    // TODO: Implement actual PDF download functionality
}
</script>

<style></style>